import { APP_ROUTES } from './constant';
import url from './url';
import { createFeedStoryPreview } from './feedStoryPreview';

// Profile browsing has a durable URL: refresh, history and section returns
// must not silently switch the reader back to the public feed.
export const opinionPath = (id, username) => username
  ? `${APP_ROUTES.USER}/${encodeURIComponent(username)}${APP_ROUTES.REACTION}/${id}`
  : `${APP_ROUTES.REACTION}/${id}`;

// The headline and score must enter exactly the same author feed and snapshot.
export const opinionLink = ({ reactionId, profileUsername, source = null, storyId = null, story }) => ({
  to: url(opinionPath(reactionId, profileUsername)),
  state: { source, storyId, ...(story ? { feedStoryPreview: createFeedStoryPreview(reactionId, story) } : {}) },
});
